function LazyImage({ src, alt, className, eager = false, width, height, ...rest }) {
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      width={width}
      height={height}
      {...rest}
    />
  );
}

export default LazyImage;
